import { render, staticRenderFns } from "./ChatMessageComponent.vue?vue&type=template&id=6815e0ad&scoped=true&"
import script from "./ChatMessageComponent.vue?vue&type=script&lang=js&"
export * from "./ChatMessageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6815e0ad",
  null
  
)

export default component.exports